import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  num: '01',
  title: 'Bloquea tu Score',
  desc: 'Implementas el "Gasto Fijo Único" para construir crédito perfecto automáticamente.'
}, {
  num: '02',
  title: 'Limpia tus Fugas',
  desc: 'Aplicas la regla de las 48 horas y eliminas los pagos que no te aportan valor.'
}, {
  num: '03',
  title: 'Automatiza tu Futuro',
  desc: 'Configuras tu sistema de inversión y ahorro para que funcione mientras duermes.'
}];
export function HowItWorks() {
  return <section className="py-24 px-6 bg-[#0f0f0f]" data-id="element-94">
      <div className="max-w-5xl mx-auto" data-id="element-95">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-20" data-id="element-96">
          <h2 className="text-3xl md:text-5xl font-bold mb-4" data-id="element-97">Cómo Funciona</h2>
          <p className="text-gray-400 text-lg" data-id="element-98">Un proceso simple en 3 pasos.</p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-99">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[10%] right-[10%] h-[1px] bg-gradient-to-r from-transparent via-gold-500/30 to-transparent" data-id="element-100" />

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="relative z-10 flex flex-col items-center text-center" data-id="element-101">
              <div className="w-24 h-24 rounded-full bg-dark border-2 border-gold-500/30 flex items-center justify-center mb-8 shadow-[0_0_30px_rgba(212,160,23,0.1)]" data-id="element-102">
                <span className="text-3xl font-display font-bold text-gold-400" data-id="element-103">
                  {step.num}
                </span>
              </div>
              <h3 className="text-2xl font-bold mb-4 text-white" data-id="element-104">
                {step.title}
              </h3>
              <p className="text-gray-400 leading-relaxed" data-id="element-105">{step.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}